export default "__VITE_ASSET__Cqc6tPuB__"